import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { RootStateCampanha } from 'campanha/src/store/campanhaReducer';
import * as S from './aprovarPedidoStyle';
import { useSearchParams } from 'react-router-dom';
import { CampanhaParameters } from '../../infra/routes/campanhaRoutes';
import { View } from 'base/src/components/Basic/View/view';
import PagedResgates from '../aprovarPedido/components/pagedResgate';
import ViewContainer from '../viewContainer/viewContainer';
import { Tabs, TabsContent } from 'base/src/components/Tabs';
import PagarPedidoContent from './components/PagarPedidoContent';
import { UsuarioSistemaPerfilEnum } from 'domain/types/usuarioSistemaPerfil/usuarioSistemaPerfilEnum';
import { useCarteira } from 'domain/utils/context/carteiraBaseContext';
import { useEffect } from 'react';
import { GetCarteiraUsuario } from 'domain/store/_carteira/carteiraBase/actions/carteiraBaseAction';
import { Redirect } from 'base/src/utils/routeUtil';
import { GetAuthRoute } from 'domain/types/sistema/sistemaList';
import { formatToBRL } from 'base/src/utils/mathUtil';
import { _UserData, UserDataBaseEnum } from 'base/src/infra/storage/localStorage';
import { CARTEIRA_URL_APP } from 'domain/infra/data/env';

const connector = connectUtil(
  (state: RootStateCampanha) => ({
    usuarioSistemaPerfil: state.UsuarioSistemaPerfilReducer.usuarioSistemaPerfil,
    TaxaPagamento: state.CarteiraBaseReducer.CarteiraBase.TaxaPagamento,
    Pagar: state.CampanhaPedidoResgateReducer.formData,
    CampanhaPedidoResgate: state.CampanhaPedidoResgateReducer.CampanhaPedidoResgateByCampanha,
  }),
  { GetCarteiraUsuario }
);

export interface AprovarPedidoProps extends PropsFromRedux<typeof connector> { }

function AprovarPedido(props: AprovarPedidoProps) {
  const [searchParams] = useSearchParams();
  const campanhaId = searchParams.get(CampanhaParameters.campanhaId);

  useEffect(() => {
    props.GetCarteiraUsuario(() => { Redirect(GetAuthRoute()) });
  }, []);

  const isAdministradorCarteira = Boolean(
    props.usuarioSistemaPerfil?.find(u =>
      u.PerfilID === UsuarioSistemaPerfilEnum.AdministradorDeCarteira
    )
  );

  const tabItems = [
    { value: 'gerenciar-saques', label: 'Gerenciar Saques' },
    ...(isAdministradorCarteira ? [{ value: 'gerenciar-lotes', label: 'Gerenciar Lotes' }] : [])
  ];

  const { walletBalance } = useCarteira();

  // Handler to open carteira with token
  function handleHeaderRowClick() {
    if (!isAdministradorCarteira) return;
    const token = _UserData.Get(UserDataBaseEnum.Token);
    if (token) {
      const url = `${CARTEIRA_URL_APP}/?token=${encodeURIComponent(String(token))}`;
      window.open(url, '_blank');
    }
  }

  return (
    <ViewContainer>
      <View >
        <Tabs action={
          <S.HeaderRow
            onClick={handleHeaderRowClick}
            style={{ cursor: 'pointer' }}
            title="Abrir carteira em nova aba"
          >
            <span style={{ fontSize: 12 }}>Saldo em conta</span>
            <S.WalletBalance>{formatToBRL(walletBalance || 0)}</S.WalletBalance>
          </S.HeaderRow>
        }
          items={tabItems}
          defaultValue="gerenciar-saques"
          style={{ marginTop: 10 }}
        >

          <TabsContent value="gerenciar-saques">
            <S.TableContainer>
              <PagedResgates
                take={5}
                campanhaId={Number(campanhaId)}
              />
            </S.TableContainer>
          </TabsContent>

          {isAdministradorCarteira && (
            <TabsContent value="gerenciar-lotes">
              <PagarPedidoContent />
            </TabsContent>
          )}
        </Tabs>
      </View>
    </ViewContainer>
  );
}

export default connector(AprovarPedido);
